import { render, staticRenderFns } from "./project-config-preview.vue?vue&type=template&id=1b888366&scoped=true"
import script from "./project-config-preview.vue?vue&type=script&setup=true&lang=js"
export * from "./project-config-preview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./project-config-preview.vue?vue&type=style&index=0&id=1b888366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b888366",
  null
  
)

export default component.exports